module.exports = __webpack_public_path__ + "static/media/ACAF Logo.475ccb34.png";